export const CONTACT = {
  phone: "(507) 360-9463",
  phoneHref: "tel:5073609463",
  email: "farra.sammy@gmail.com",
  hours: "Mon–Sun · 9am – 6pm",
  region: "Serving the Minneapolis–St. Paul metro",
  googleReviewUrl: "https://share.google/5ELvFFv8KSuLIdsYH",
  googleWriteReviewUrl: "https://g.page/r/CXQYwx46gjfeEBM/review",
};

export const HERO_IMG = "/hero-garage.jpg";

export const BENEFITS = [
  { title: "Room for what matters", body: "Fit both cars, the bikes, and everything in between — no more curbside parking or turning sideways to squeeze past clutter.", tag: "Space" },
  { title: "Clean to the corners", body: "Floors scrubbed, walls wiped, cobwebs cleared. Every surface gets attention until the space genuinely feels new.", tag: "Fresh" },
  { title: "Everything has a home", body: "Sorted, labeled, and within arm's reach. Finding a tool takes seconds instead of half your afternoon.", tag: "Order" },
  { title: "We carry the load", body: "Lifting, sorting, hauling, deciding — all of it is on us. You just point us at the finish line.", tag: "Easy" },
];

export const STEPS = [
  { no: "01", title: "Tell us about it", body: "Book a quick walkthrough. We size up the space, talk through your goals, and flag any upgrades worth adding — free, no strings." },
  { no: "02", title: "Pick your day", body: "Choose a date that fits your week. We confirm the plan and lay out exactly what happens once we arrive." },
  { no: "03", title: "Come home to it", body: "In a single visit we clear, clean, and install. You walk back into a garage that finally works for you." },
];

export const GALLERY = [
  { name: "The Hartzell Garage", location: "Twin Cities, MN",
    before: "/hartzell-before.webp",
    after: "/hartzell-after.webp" },
];

export const SERVICES = [
  { title: "LED Lighting", body: "Bright overhead lighting mounted the same day, turning dim corners into space you'll actually use.", icon: "Lightbulb" },
  { title: "Custom Shelving", body: "Sturdy, made-to-fit shelving that we deliver, build, and stock before we head out.", icon: "LayoutGrid" },
  { title: "Labeled Totes", body: "Stackable, clearly labeled bins so every loose item finally lands somewhere it belongs.", icon: "Boxes" },
  { title: "Door Tune-Up", body: "We lubricate, tighten, and inspect the hardware so your garage door opens quiet and smooth.", icon: "Wrench" },
  { title: "Tool Walls", body: "Wall-mounted pegboards and hooks that keep everything visible and a single reach away.", icon: "Grip" },
  { title: "Free Hauling", body: "A full trailer load leaves with us at no extra cost — old furniture, appliances, junk and all.", icon: "Truck" },
];

export const TESTIMONIALS = [
  { name: "Susan Hartzell", when: "2 days ago", body: "The garage cleaners were awesome. Very thorough. Really nice guys." },
];

export const TEAM = [
  { name: "Sammy Farra", role: "Garage Cleaning Specialist", body: "Owner, operator, and the person on-site for every single job. Sammy handles the plan, the heavy lifting, and the finishing touches — start to finish, done right.",
    img: "/team-sammy.webp" },
];

export const SERVICE_AREAS = [
  "Minneapolis", "St. Paul", "Andover", "Anoka", "Apple Valley", "Arden Hills", "Blaine",
  "Bloomington", "Brooklyn Center", "Brooklyn Park", "Burnsville", "Champlin", "Chanhassen",
  "Chaska", "Circle Pines", "Columbia Heights", "Coon Rapids", "Corcoran", "Cottage Grove",
  "Crystal", "Dayton", "Deephaven", "Eagan", "Eden Prairie", "Edina", "Excelsior",
  "Falcon Heights", "Fridley", "Golden Valley", "Grant", "Ham Lake", "Hopkins", "Hugo",
  "Inver Grove Heights", "Lake Elmo", "Lauderdale", "Lino Lakes", "Little Canada", "Mahtomedi",
  "Maple Grove", "Maplewood", "Medina", "Mendota Heights", "Minnetonka", "Mound", "Mounds View",
  "New Brighton", "New Hope", "Newport", "North Oaks", "North St. Paul", "Oakdale", "Orono",
  "Osseo", "Plymouth", "Prior Lake", "Ramsey", "Richfield", "Robbinsdale", "Rogers",
  "Rosemount", "Roseville", "St. Anthony", "St. Louis Park", "St. Paul Park", "Savage",
  "Shakopee", "Shoreview", "Shorewood", "South St. Paul", "Spring Lake Park", "Stillwater",
  "Vadnais Heights", "Wayzata", "West St. Paul", "White Bear Lake", "Woodbury",
];

export const SERVICE_TYPES = [
  "Full Garage Cleanout", "Deep Clean Only", "Organization & Shelving",
  "Junk / Haul-Away", "Complete Makeover (all add-ons)", "Not sure — need advice",
];
